import { api } from '../api';

export interface ImportExportResult {
  sucesso: boolean;
  mensagem: string;
  dados?: any;
  detalhes?: string[];
}

/**
 * Serviço centralizado para importação e exportação de dados
 * Usa o cliente API centralizado que inclui automaticamente o token de autenticação
 */
export class ImportExportService {
  
  /**
   * Baixa arquivo de exemplo para o tipo especificado
   * @param tipo - Tipo de entidade (pacientes, consultas, catalogos)
   */
  async baixarExemplo(tipo: 'pacientes' | 'consultas' | 'catalogos'): Promise<Blob> {
    console.log(`[ImportExportService] Baixando exemplo para ${tipo}...`);
    
    try {
      const response = await api.get(`/exemplo/${tipo}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      console.log(`[ImportExportService] Exemplo de ${tipo} baixado com sucesso`);
      return response.data;
      
    } catch (error) {
      console.error(`[ImportExportService] Erro ao baixar exemplo de ${tipo}:`, error);
      throw error;
    }
  }
  
  /**
   * Exporta dados do tipo especificado
   * @param tipo - Tipo de entidade (pacientes, consultas, catalogos)
   */
  async exportarDados(tipo: 'pacientes' | 'consultas' | 'catalogos'): Promise<Blob> {
    console.log(`[ImportExportService] Exportando dados de ${tipo}...`);
    
    try {
      const response = await api.post(`/exportar/${tipo}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      console.log(`[ImportExportService] Dados de ${tipo} exportados com sucesso`);
      return response.data;
      
    } catch (error) {
      console.error(`[ImportExportService] Erro ao exportar dados de ${tipo}:`, error);
      throw error;
    }
  }
  
  /**
   * Importa dados do arquivo CSV
   * @param tipo - Tipo de entidade (pacientes, consultas, catalogos)
   * @param csvContent - Conteúdo do arquivo CSV
   */
  async importarDados(tipo: 'pacientes' | 'consultas' | 'catalogos', csvContent: string): Promise<ImportExportResult> {
    console.log(`[ImportExportService] Importando dados de ${tipo}...`);
    
    try {
      const response = await api.post(`/importar/${tipo}`, {
        csv: csvContent
      });
      
      console.log(`[ImportExportService] Dados de ${tipo} importados:`, {
        sucesso: response.data.sucesso,
        mensagem: response.data.mensagem
      });
      
      return response.data;
      
    } catch (error: any) {
      console.error(`[ImportExportService] Erro ao importar dados de ${tipo}:`, error);
      
      if (error.response?.data) {
        return error.response.data;
      }
      
      throw error;
    }
  }
  
  /**
   * Utilitário para baixar blob como arquivo
   * @param blob - Blob de dados
   * @param filename - Nome do arquivo
   */
  baixarArquivo(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}

// Exportar instância singleton
export const importExportService = new ImportExportService();
